const Constants = {
    scales: {
        types: {
            TYPE_QUALITY: 'quality',
            TYPE_QUANTITY: 'quantity',
        },
        typesSelectOptions: [
            {id: 'quality', name: 'Качественная'},
            {id: 'quantity', name: 'Количественная'}
        ],
    },


    elementChildValuesAggregate: {
        types: {
            TYPE_MANUAL           :  1,
            TYPE_AVERAGE          :  2,
            TYPE_WEIGHTED_AVERAGE :  3,
            TYPE_SUM              :  4,
            TYPE_MIN              :  5,
            TYPE_MAX              :  6,
            TYPE_PERFORMANCE      :  7,
            TYPE_PROGRESS         :  8,
        },
        typesSelectOptions: [
            {id: 1, name: 'Ручное'},
            {id: 2, name: 'Среднее'},
            {id: 3, name: 'Взвешенное среднее'},
            {id: 4, name: 'Сумма'},
            {id: 5, name: 'Мин'},
            {id: 6, name: 'Макс'},
            {id: 7, name: 'Прогресс'},
            {id: 8, name: 'Производительность'},
        ],
    },
    elementChildPerformanceAggregate: {
        types: {
            TYPE_MANUAL           :  1,
            TYPE_AVERAGE          :  2,
            TYPE_WEIGHTED_AVERAGE :  3,
            TYPE_SUM              :  4,
            TYPE_MIN              :  5,
            TYPE_MAX              :  6,
        },
        typesSelectOptions: [
            {id: 1, name: 'Ручное'},
            {id: 2, name: 'Среднее'},
            {id: 3, name: 'Взвешенное среднее'},
            {id: 4, name: 'Сумма'},
            {id: 5, name: 'Мин'},
            {id: 6, name: 'Макс'},
        ],
    },

    elementCardAssign: {
        types: {
            TYPE_MANUAL: 1,
            TYPE_VQB:    2,
        },
    },
    elementAutoCascading: {
        types: {
            TYPE_MANUAL: 1,
            TYPE_VQB:    2,
        },

        targetPartitionTypes: {
            TYPE_MANUAL:           1,
            TYPE_SAME_TO_PARENT:   2,
            TYPE_EQUAL_PARTITIONS: 3,
        },
        targetPartitionTypesSelectOptions: [
            {id: 1, name: 'Ручное'},
            {id: 2, name: 'Как у родителя'},
            {id: 3, name: 'Равные доли от родителя'},
        ],
    },


}

export default {
    install(Vue) {
        Vue.prototype.$cascadingConstants = Constants;
    },

}

export { Constants }